<template>
    <div class="preview-slot">
  
      <!-- Sem template: botão para abrir o seletor -->
      <div v-if="!selectedTemplate" class="pw-empty">
        <button class="pw-btn-select" @click="$emit('open-selector')">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M3 9h18M9 21V9" />
          </svg>
          Selecionar template
        </button>
      </div>
  
      <!-- Com template: bolha de preview + botão de troca -->
      <div v-else class="pw-bubble-wrap">
        <div class="pw-bubble-group">
          <div class="pw-bubble">
            <div v-if="headerText" class="pw-bubble__header">{{ headerText }}</div>
            <div class="pw-bubble__body" v-html="formattedBody"></div>
            <div v-if="footerText" class="pw-bubble__footer">{{ footerText }}</div>
            <div class="pw-bubble__meta">
              <span class="pw-bubble__time">agora</span>
              <svg width="14" height="10" viewBox="0 0 16 11" fill="none">
                <path d="M1 5.5l3.5 3.5 5-8" stroke="#25d366" stroke-width="1.5" stroke-linecap="round" />
                <path d="M6 5.5l3.5 3.5 5-8" stroke="#25d366" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
          </div>
          <!-- Botões colados abaixo da bolha -->
          <div v-if="templateButtons.length" class="pw-bubble-buttons">
            <button v-for="(btn, i) in templateButtons" :key="i" class="pw-bubble-btn">
              <i v-if="btn.type === 'QUICK_REPLY'" class="fas fa-reply"></i>
              <i v-else-if="btn.type === 'URL'" class="fas fa-external-link-alt"></i>
              <i v-else-if="btn.type === 'PHONE_NUMBER'" class="fas fa-phone"></i>
              {{ btn.text }}
            </button>
          </div>
        </div>
        <button class="pw-btn-change" @click="$emit('open-selector')">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="23 4 23 10 17 10" />
            <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
          </svg>
          Trocar template
        </button>
      </div>
  
    </div>
  </template>
  
  <script>
  export default {
    props: {
      selectedTemplate: { type: Object, default: null },
      variables: { type: Array, default: function () { return []; } }
    },
    computed: {
      headerText() {
        if (!this.selectedTemplate) return '';
        var comps = this.selectedTemplate.components || [];
        var h = comps.find(function (c) { return c.type === 'HEADER' && c.format === 'TEXT'; });
        return h ? h.text : '';
      },
      bodyComp() {
        if (!this.selectedTemplate) return null;
        var comps = this.selectedTemplate.components || [];
        return comps.find(function (c) { return c.type === 'BODY'; }) || null;
      },
      footerText() {
        if (!this.selectedTemplate) return '';
        var comps = this.selectedTemplate.components || [];
        var f = comps.find(function (c) { return c.type === 'FOOTER'; });
        return f ? f.text : '';
      },
      templateButtons() {
        if (!this.selectedTemplate) return [];
        var comps = this.selectedTemplate.components || [];
        var b = comps.find(function (c) { return c.type === 'BUTTONS'; });
        return b ? (b.buttons || []) : [];
      },
      formattedBody() {
        if (!this.bodyComp) return '';
        var text = this.bodyComp.text || '';
        var vars = this.variables;
        vars.forEach(function (v, i) {
          var re = new RegExp('\\{\\{' + (i + 1) + '\\}\\}', 'g');
          var val = v.value
            ? '<strong>' + v.value + '</strong>'
            : '<span class="pw-var">{{' + (i + 1) + '}}</span>';
          text = text.replace(re, val);
        });
        text = text.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
        text = text.replace(/_(.*?)_/g, '<em>$1</em>');
        text = text.replace(/\n/g, '<br>');
        return text;
      }
    }
  };
  </script>
  
  <style scoped>
  .preview-slot {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 290px;
    width: 100%;
    overflow-y: auto;
    background: repeat url(/images/background-wpp.png) #e6ded5;
    background-size: 80%;
    background-blend-mode: soft-light;
    position: relative;
  }
  
  /* Estado vazio */
  .pw-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex: 1;
  }
  
  .pw-btn-select {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: rgba(255, 255, 255, .92);
    border: 1.5px solid #d1d7db;
    border-radius: 20px;
    padding: 8px 18px;
    font-size: 13px;
    font-weight: 600;
    color: #111b21;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, .12);
    transition: border-color .15s, box-shadow .15s;
  }
  
  .pw-btn-select:hover {
    border-color: #00a884;
    box-shadow: 0 2px 8px rgba(0, 168, 132, .18);
  }
  
  /* Bubble */
  .pw-bubble-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    gap: 8px;
  }
  
  /* Agrupa bolha + botões sem gap entre eles */
  .pw-bubble-group {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-width: 78%;
  }
  
  .pw-bubble {
    background: #fff;
    border-radius: 0 10px 10px 10px;
    padding: 8px 12px 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
    word-break: break-word;
  }
  
  .pw-bubble__header {
    font-size: 14px;
    font-weight: 700;
    color: #111b21;
    margin-bottom: 4px;
  }
  
  .pw-bubble__body {
    font-size: 13px;
    color: #111b21;
    line-height: 1.55;
  }
  
  .pw-bubble__footer {
    font-size: 12px;
    color: #667781;
    margin-top: 4px;
  }
  
  .pw-bubble__meta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 3px;
    margin-top: 4px;
  }
  
  .pw-bubble__time {
    font-size: 11px;
    color: #667781;
  }
  
  /* Botões colados abaixo da bolha */
  .pw-bubble-buttons {
    display: flex;
    flex-direction: column;
    gap: 1px;
    margin-top: 2px;
  }
  
  .pw-bubble-btn {
    width: 100%;
    background: #fff;
    border: none;
    border-top: 1px solid #e9edef;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 500;
    color: #00a5f4;
    cursor: default;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  
  .pw-bubble-btn:last-child {
    border-radius: 0 0 10px 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
  }
  
  .pw-btn-change {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: rgba(255, 255, 255, .85);
    border: 1px solid #d1d7db;
    border-radius: 12px;
    padding: 4px 12px;
    font-size: 11px;
    font-weight: 600;
    color: #667781;
    cursor: pointer;
    transition: border-color .15s, color .15s;
  }
  
  .pw-btn-change:hover {
    border-color: #00a884;
    color: #00a884;
  }
  </style>